import { GetSurveyInstanceError } from 'Services/SurveyInstanceService';

interface ErrorStateProps {
	error: GetSurveyInstanceError;
}

export default function ErrorState(props: ErrorStateProps) {
	const { error } = props;

	let message = 'An unknown error occurred.';
	if (error === 'SURVEY_INSTANCE_NOT_FOUND') {
		message = 'Survey not found.';
	} else if (error === 'SURVEY_INSTANCE_EXPIRED') {
		message = 'This survey has expired.';
	} else if (error === 'SURVEY_RESPONDED') {
		message = 'This survey has already been filled out.';
	}

	return (
		<div className="error-state-container">
			<span className="material-symbols-outlined">error</span>
			<p>{message}</p>
		</div>
	);
}
